module.exports = __webpack_public_path__ + "img/googleplay.10f57266.svg";